import { sendNotificationService } from "../infrastructure/services/sendNotificationService";
import { NotificationActions, NotificationSendRequest } from "../domain/notification";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const sendNotification = {
    async execute(title: string,
        body: string): Promise<void> {
        const request: NotificationSendRequest =
            await NotificationActions().createNotificationSendRequest(
                title,
                body
            );
        await sendNotificationService.execute(await tokenValidation.execute(), request);
    },
};
